import { useApiQuery } from './useApiQuery';
import { useApiMutation } from './useApiMutation';
import { queryKeys } from './queryKeys';
import { roleService } from '@/services/roleService';
import { APIError } from '@/utils/api-client';

// Query for permission matrix
export const usePermissionMatrix = () => {
  return useApiQuery(
    queryKeys.roles.permissions(),
    () => roleService.getPermissionMatrix(),
    {
      // Permissions rarely change, cache for 10 minutes
      staleTime: 10 * 60 * 1000,
    }
  );
};

// Mutation for assigning permissions to a role
export const useAssignRolePermissions = () => {
  return useApiMutation<
    { success: boolean },
    APIError,
    { id: string; permissionIds: string[] }
  >(
    ({ id, permissionIds }) =>
      roleService.assignRolePermissions(id, permissionIds),
    {
      invalidateKeys: (_data, variables) => [
        queryKeys.roles.all,
        ['roles', variables.id],
        queryKeys.roles.permissions(),
      ],
      successMessage: 'Permissions updated successfully',
    }
  );
};
